



























import Vue from 'vue';
import CommunityNotificationItem from './CommunityNotificationItem.vue';

export default Vue.extend({
  name: 'CommunityNotificationsList',
  components: {
    CommunityNotificationItem,
  },
  props: {
    isStudio: {
      type: Boolean,
      default: false,
    },
    openInNewWindow: {
      type: Boolean,
      default: false,
    },
    magicCode: {
      type: String,
      default: null,
    },
    maxNotifications: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    notifications() {
      return this.isStudio
        ? this.$store.state.community.studioNotifications
        : this.$store.state.community.notifications;
    },
    parsedNotifications() {
      const result = [];
      const results = this.notifications?.results || [];
      if (this.maxNotifications) {
        results.splice(this.maxNotifications);
      }
      results.forEach(n => {
        const actorCount = n.actor_count;
        const activityCount = n.activity_count;
        const verb = n.verb;
        const firstActivity = n.activities[0];
        result.push({
          verb: verb,
          time: firstActivity.time,
          actor: firstActivity.actor,
          actorCount: actorCount,
          activityCount: activityCount,
          extraData: firstActivity.extra_data,
          object: firstActivity.object,
          activities: n.activities,
          isSeen: n.is_seen,
          id: n.id,
        });
      });

      return result;
    },
    getLoadNotificationsAction() {
      return this.isStudio
        ? 'community/loadStudioNotifications'
        : 'community/loadNotifications';
    },
    getLoadNextNotificationsAction() {
      return this.isStudio
        ? 'community/loadNextStudioNotifications'
        : 'community/loadNextNotifications';
    },
  },
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    async loadNotifications() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(this.getLoadNotificationsAction, {
          markSeen: this.markSeen,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadNotifications();
  },
});
